
<template>
  <div>
    <base-card class="my-2">
      <template slot="title">
        <span class="text-capitalize pa-2 font-weight-bold">
          {{ $t('tasks.next_tasks')}} 
        </span>
        <span class="subtitle-1">
          ({{ $t('tasks.next_tasks_explain') }})
        </span>
      </template>
      <template slot="content">
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <div v-if="!loading && !tasks.length">
          {{ $t('tasks.none') }}
        </div>
        <div v-if="!loading && tasks.length">
          <task-small-card @click="handleClick" with_users with_subtasks with_status v-for="task in tasks" :key="task.id" :task="task"></task-small-card>

        </div>
      </template>
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'NextTasks',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      tasks: [],
      loading: false,
    }
  },
  methods: {
    handleClick(e){
      this.$router.push({name: 'ShowTask', params: {id: e.task_id}})
    },
    getNextTasks() {
      let filter = {
        searches: {
          // users_id_eq: this.profile.id,
          use_type_eq: 1, //official
          due_at_gt: this.$dayjs().endOf('week').format(),
          due_at_lteq: this.$dayjs().endOf('month').format(),
        },
        sorts: [
          'due_at asc'
        ]
      }
      this.loading = true
      Api.Task.index(filter).then(r=>r.data).then(d=> {
        this.tasks = [...d]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        setTimeout(() => {
          this.loading = false
        }, 500);
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getNextTasks();
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>